const ANONYMIZE = "anonymize";

class AnonymizeHandler {
  static setAnonymize = (anonymize: boolean) => {
    localStorage.setItem(ANONYMIZE, anonymize.toString());
  };
  static hasAnonymized = () => !!localStorage.getItem(ANONYMIZE);
  static getAnonymize = () => localStorage.getItem(ANONYMIZE);
  static clearAnonymize = () => {
    localStorage.removeItem(ANONYMIZE);
  };
}

export default AnonymizeHandler;
